import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import type { OptionSchema } from 'c-components';
import { Autocomplete } from 'c-components';
import { useCommonTranslation } from 'c-translation';
import { useAuthenticatedUser } from 'c-hooks';
import type { Skin } from 'c-data';
import { useEntityData } from 'c-data';

type Props = {
    onChange: (skinId: number) => void;
    selectedSkinId: number;
};

const NonAdminSkinSwitcher: React.FC<Props> = ({ onChange, selectedSkinId }) => {
    const { keyedEntities } = useEntityData<Skin>('Skin');
    const { user } = useAuthenticatedUser();
    const options = useMemo<OptionSchema[]>(() => {
        const skins = user?.skins;
        if (Array.isArray(skins)) {
            return skins
                .filter(entityId => keyedEntities[entityId] != null)
                .map(entityId => ({
                    value: keyedEntities[entityId]?.id,
                    label: keyedEntities[entityId]?.name,
                }));
        }

        return [];
    }, [user?.skins, keyedEntities]);

    return (
        // Stop keydown reaching the parent avatar Menu, whose type-ahead otherwise steals
        // letters that match a menu item's first character (e.g. "d"/"s") while typing here.
        <Box py={2} onKeyDown={e => e.stopPropagation()}>
            <Autocomplete
                options={options}
                multiple={false}
                value={selectedSkinId}
                onChange={onChange}
                textFieldProps={{
                    label: useCommonTranslation('Modules.Admin.SkinSwitcher.dropdownLabel'),
                }}
            />
        </Box>
    );
};

export default NonAdminSkinSwitcher;
